/* eslint-disable no-console */
class PaginationController {
   $scope: any
   appState: any
   resultsFeedService: any
   config: any
   resultsConfig: any
   resultsFeedScope: any
   searchService: SearchService
   $window: any
   citationTrail: any
   searchTabs: any
   viewState: ViewStateService
   courseReserve: CourseReserveService
  
   constructor($scope: any, appState: any, resultsFeedService: any, config: ConfigService, searchService: SearchService, $window: any, citationTrail: any, courseReserve: CourseReserveService, $searchTabs: any, viewState: ViewStateService) {
      this.$onInit = this.$onInit.bind(this)
      this.$scope = $scope
      this.resultsFeedScope = this.$scope.$parent
      this.appState = appState
      this.resultsFeedService = resultsFeedService
      this.config = config
      this.resultsConfig = this.config.data.results
      this.$scope.currentPage = this.appState.params.pn || 1
      this.$scope.itemsPerPage = this.$scope.itemsPerPage || this.resultsConfig.pageSize
      this.$scope.maxItems = this.resultsConfig.pageSize * this.resultsFeedService.maxPages      
      this.$scope.pageChanged = this.pageChanged.bind(this)
      this.searchService = searchService
      this.$window = $window
      this.citationTrail = citationTrail
      this.searchTabs = $searchTabs
      this.viewState = viewState
      this.courseReserve = courseReserve
      
      this.$scope.$watch('itemsCount', (itemsCount: number) => this.$scope.currentMax = itemsCount ? Math.min(this.$scope.maxItems, itemsCount) : itemsCount)
   }
   
   $onInit() {
      // Setup max number of pages in pagination according to screen size
      this.setPaginationSizeOnScreenSize()
      
      // Used for back/forward browser buttons
      this.$window.addEventListener('popstate', this.extractPageFromUrl.bind(this))

      // Define max page number of pagination according to screen size
      this.$window.addEventListener('resize', this.setPaginationSizeOnScreenSize.bind(this))
      
      // Setup pagne number according to view: search or citation
      this.alignPageNumberWithView()
   }

   /**
    * For large screens: max page number of pagination = 4
    * For small screens: max page number of pagination = 3
    */
   setPaginationSizeOnScreenSize() {
      if(this.$window.innerWidth <= 1024) {
         this.$scope.maxSize = 3
      } else {
         this.$scope.maxSize = 4
      }
   }


   /**
    * This function extracts the PageNumber from url and load the page requested. Used for back/forward button of the browser. 
    * In case the page is being switched from QuickLook, since the page is alrewady switching in that process, we prevent to do it twice. 
    */
   extractPageFromUrl() {
      const stringAfterPn = window.location.hash.split('pn=')[1]
      if(stringAfterPn){
         const pageNum = stringAfterPn.split('&')[0]
         if(pageNum != this.$scope.currentPage){
            this.$scope.currentPage = +pageNum
            if (this.viewState.subView != 'quick-look') {
               this.pageChanged()
            }
         }
      }
   }

   /**
    * In Search view: set current page number to be as pn value. 
    * In Citation view: set current page to 1 
    */
   alignPageNumberWithView() {
      if(this.$scope.view === 'search') {
         this.$scope.currentPage = +this.appState.params.pn
      } else if (this.$scope.view === 'citation-trail' && this.$scope.selectedTab == this.searchTabs.citationTrail) {
         this.$scope.currentPage = this.citationTrail.currentPage || 1
      } else if (this.$scope.view === 'course-reserves') {
         this.$scope.currentPage = this.courseReserve.scope.page
      } else if (this.$scope.view === 'course-reserves-detail') {
         this.$scope.currentPage = this.courseReserve.detailScope.pn
      }
   }

   /**
    * Change page. Use await mostly for case of back/forward button of browser. 
    * If not it loads the previous/next page with a delay.
    */
   pageChanged = async () => {
      if (this.$scope.view === 'search') {
         this.resultsFeedScope.newSearchInfo.isNewSearch = false
         this.resultsFeedScope.viewState.currentView = 'search'
         if (this.resultsFeedScope.deferAutocompleteAbort) {
            this.resultsFeedScope.deferAutocompleteAbort.resolve()
         }
         await this.resultsFeedService.loadPage(this.$scope.currentPage)
      } else if (this.$scope.view === 'citation-trail' && this.$scope.selectedTab == this.searchTabs.citationTrail) {
         this.citationTrail.currentPage = this.$scope.currentPage
         await this.citationTrail.loadPage(this.$scope.currentPage)
      } else if (this.$scope.view === 'course-reserves'){
         this.courseReserve.get(this.$scope.currentPage)
      } else if (this.$scope.view === 'course-reserves-detail'){
         this.courseReserve.getDetailDocs(this.$scope.currentPage)
      }
   }

}
 
PaginationController.$inject = ['$scope', 'appStateService', 'resultsFeedService', 'configService', 'searchService', '$window', 'citationTrailService', 'courseReserveService', '$searchTabs', 'viewStateService']
 
angular.module('summonApp.controllers')
   .controller('PaginationCtrl', PaginationController)
 
 
